import { render, staticRenderFns } from "./PortfolioSearchSelect.vue?vue&type=template&id=d52d27ec&scoped=true&"
import script from "./PortfolioSearchSelect.vue?vue&type=script&lang=js&"
export * from "./PortfolioSearchSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d52d27ec",
  null
  
)

export default component.exports